// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"8633":"css/app.6757","9012":"css/admin-app.6757"}[chunkId] + ".css";
};